import { gsap } from 'gsap';

export function testimonialFade() {
    // get text if a descendent of .fade-testimonial-holder
    const testimonials = document.querySelectorAll('.fade-testimonial-holder .text');

    const tl = gsap.timeline({
        // loop element
        repeat: -1
    });

    testimonials.forEach((testimonial) => {
        // fade testimonial in..
        tl.to(testimonial, {
            opacity: 1,
            duration: 3
        });

        // fade out testimonial out..
        tl.to(testimonial, {
            opacity: 0,
            duration: 4
        });
    });
}
